import { Paper, Typography } from "@mui/material";

import { useGetApp } from "../hook/useGetApp";

export default function DialogPaper() {
	const app = useGetApp();

	return (
		<Paper elevation={3} sx={{ p: 3, mx: 3, mt: 2 }}>
			<Typography variant='subtitle2'>{app?.name}</Typography>
		</Paper>
	);
}
